import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { OffboardingService, ROUTES } from '@common/interfaces';
import { SignInService } from './sign-in/sign.in.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly router = inject(Router);
  private readonly signInService = inject(SignInService);
  private readonly offboardingService = inject(OffboardingService);

  // logOut() {
  //   localStorage.clear();
  // }

  logOutWithApi(onComplete: () => void) {
    this.signInService.logOutApi().subscribe({
      next: () => {
        this.clearStoredSession();
        onComplete();
      },
      error: () => {
        this.clearStoredSession();
        onComplete();
      },
    });
  }

  private clearStoredSession(): void {
    localStorage.clear();
    this.offboardingService.clearSession();
  }

  checkUserRole(route: ActivatedRouteSnapshot, url: string) {
    const userData = JSON.parse(localStorage.getItem('userInfo') as string);
    const token = localStorage.getItem('token') as string;
    if (!userData || !token || !Object.keys(userData).length) {
      localStorage.setItem('returnUrl', url);
      this.router.navigate([ROUTES.SIGN_IN]);
      return false;
    }
    return true;
  }
}
